import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

class OrderBekreftetGrunnbok extends Component {
    state = {
        isLoading: false,
        orderError: null,
        orderReference: null,
        erBestilt: false
    }

    UNSAFE_componentWillMount = () => {
        this.getBestillingStatus()
    }

    getBestillingStatus = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/utskriftbestillingstatus/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                erBestilt: data.erBestilt,
                isLoading: false
            })
        })
    }

    sendOrder = () => {
        if (this.state.isLoading) return;        
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/bestillbekreftetgrunnbok/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer,
                navn: this.fulltnavn.value,
                adresse: this.gatenavnognummer.value,
                postnummer: this.postnummer.value,
                fakturareferanse: this.fakturareferanse.value
            }
        })
        .then(({data}) => {
            this.setState({
                isLoading: false,
                orderError: data.feil,
                orderReference: data.referansenummer ? data.referansenummer : null
            })
        })
    }

    render() {
        const { t } = this.props

        return (
            <li>
                <div className="section-header navigation" onClick={this.props.onNavigateBack}>
                    <span className="icon"><i className={"fa fa-fw fa-arrow-left"}></i></span>
                    <span className="title">{t('tilbake')}</span>
                </div>

                <div className="section-header defaultcursor">
                    <span className="icon"><i className={"fa fa-fw fa-image"}></i></span>
                    <span className="title">{t('bestillbekreftetgrunnbok')}</span>
                </div>

                { this.state.orderReference == null &&
                <React.Fragment>
                    <div className="section-header defaultcursor description multiline">
                        {t('registreradresse')}
                    </div>

                    <div className="section-header defaultcursor order-label topborder">
                        <span className="title">{t('fulltnavn')}</span>
                    </div>

                    <div className="section-header defaultcursor order-input">
                        <input type="text" ref={input => this.fulltnavn = input} />
                    </div>

                    <div className="section-header defaultcursor order-label">
                        <span className="title">{t('gatenavnognummer')}</span>
                    </div>

                    <div className="section-header defaultcursor order-input">
                        <input type="text" ref={input => this.gatenavnognummer = input} />
                    </div>

                    <div className="section-header defaultcursor order-label">
                        <span className="title">{t('postnummer')}</span>
                    </div>

                    <div className="section-header defaultcursor order-input postnummer">
                        <input type="text" ref={input => this.postnummer = input} />
                    </div>

                    <div className="section-header defaultcursor order-label">
                        <span className="title">{t('fakturareferanse')}</span>
                    </div>

                    <div className="section-header defaultcursor order-input postnummer">
                        <input type="text" maxLength="15" ref={input => this.fakturareferanse = input} />
                    </div>

                    { this.state.erBestilt &&
                            <div className="section-header defaultcursor description">
                                <span className="title">{t('dokumentalleredebestilt')}</span>
                            </div>
                    }

                    { this.state.orderError != null &&
                        <div className="section-header defaultcursor description multiline">
                            <span className="title">{this.state.orderError}</span>
                        </div>
                    }

                    <div className="section-header defaultcursor buttons">
                        <div className="button buttonspinner" onClick={this.sendOrder}>
                            <span className="icon"><i className={`${this.state.isLoading ? 'fa fa-fw fa-spinner fa-spin' : 'fa fa-fw'}`}></i></span>
                            <span>{t('sendbestilling')}</span>
                        </div>
                    </div>
                </React.Fragment>
                }

                { this.state.orderReference != null &&
                    <div className="section-header defaultcursor multiline topborder">
                        {t('bekreftetgrunnbokbestilt', { kommunenummer: this.props.kommunenummer, gardsnummer: this.props.gardsnummer, bruksnummer: this.props.bruksnummer, festenummer: this.props.festenummer, seksjonsnummer: this.props.seksjonsnummer, referanse: this.state.orderReference })}
                    </div>
                }
            </li>
        )
    }
}

export default withTranslation('common')(OrderBekreftetGrunnbok)